import api from './client';

export const getSessions = () => api.get('/wa-sessions');
export const getSession = (id) => api.get(`/wa-sessions/${id}`);
export const createSession = (data) => api.post('/wa-sessions', data);
export const deleteSession = (id) => api.delete(`/wa-sessions/${id}`);
export const connectSession = (id) => api.post(`/wa-sessions/${id}/connect`);
export const getQR = (id) => api.get(`/wa-sessions/${id}/qr`);
export const disconnectSession = (id) => api.post(`/wa-sessions/${id}/disconnect`);
export const logoutSession = (id) => api.post(`/wa-sessions/${id}/logout`);
